import axios from 'axios';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

// Ensure config is loaded
if (!window.APP_CONFIG) {
  console.warn('APP_CONFIG not loaded, using fallback URLs');
}

const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL || 'https://api.title-manager.rduboue.people.aws.dev/';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth interceptor with Amplify v6
api.interceptors.request.use(async (config) => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    console.log('No valid session:', error);
  }
  return config;
});

export const titleAPI = {
  // List titles
  listTitles: (params = {}) => api.get('/content', { params }),
  
  // Get title by ID
  getTitle: (id) => api.get(`/content/${id}`),
  
  // Create title
  createTitle: (data) => api.post('/content', data),
  
  // Update title
  updateTitle: (id, data) => api.put(`/content/${id}`, data),
  
  // Delete title
  deleteTitle: (id, cascade = false) => api.delete(`/content/${id}?cascade=${cascade}`),
  
  // Search titles
  searchTitles: (params) => api.get('/content/search', { params }),
  
  // Enrich from IMDb
  enrichFromIMDb: (data) => api.post('/content/enrich', data),
  
  // Update external IDs
  updateExternalIds: (id, data) => api.put(`/content/${id}/external-ids`, data),
  
  // Chat with AI Assistant
  chatWithAI: (message, sessionId) => api.post('/chat', { message, session_id: sessionId }),
  
  // Version management
  listVersions: (titleId) => api.get(`/content/${titleId}/versions`),
  getVersion: (titleId, versionId) => api.get(`/content/${titleId}/versions/${versionId}`),
  createVersion: (titleId, data) => api.post(`/content/${titleId}/versions`, data),
  updateVersion: (titleId, versionId, data) => api.put(`/content/${titleId}/versions/${versionId}`, data),
  deleteVersion: (titleId, versionId) => api.delete(`/content/${titleId}/versions/${versionId}`),
};

export default api;